/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-nested-ternary */
import * as React from 'react';
import { Icon, MarkdownHTML } from '..';

type AlertProps = {
  show: boolean;
  type: 'SUCCESS' | 'ERROR' | 'WARNING' | 'INFO';
  message: string;
  onClose: () => void;
  onClick?: () => void;
  pending?: boolean;
  className?: string;
};

function Alert({
  show,
  type,
  message,
  className,
  pending,
  onClose,
  onClick,
}: AlertProps) {
  const alertRef = React.useRef<HTMLDivElement | null>(null);

  React.useEffect(() => {
    if (show) {
      alertRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
        inline: 'nearest',
      });
    }
  }, [show]);

  const handleOnClose = (e: any) => {
    e.stopPropagation();
    onClose();
  };

  return (
    <div
      ref={alertRef}
      onClick={onClick}
      role="presentation"
      className={`absolute top-0 font-normal flex items-center 
      justify-center text-base space-x-4 right-0 left-0 text-center transition-all 
      ease-in-out bg-pos-deep-orange hyperlink-alert 
      ${className || ''}
      ${onClick ? 'cursor-pointer' : 'cursor-default'}
      ${show ? 'min-h-[50px] p-[5px]' : 'h-0'}
      ${
        type === 'SUCCESS'
          ? 'bg-[#72c16d] text-white success'
          : type === 'WARNING'
          ? 'bg-pos-deep-orange text-white warning'
          : type === 'INFO'
          ? 'bg-[#FFE0AF] text-pos-black info'
          : 'bg-pos-red text-white error'
      }`}
    >
      {show && (
        <>
          {pending ? (
            <span className="pending-alert">
              <MarkdownHTML content={message} />
            </span>
          ) : (
            <>
              <span>
                <MarkdownHTML content={message} />
              </span>
              <div
                role="presentation"
                onClick={handleOnClose}
                className="p-[10px]"
              >
                <Icon id="close" className="w-[12px] h-[12px] cursor-pointer" />
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
}

Alert.defaultProps = {
  className: '',
  pending: false,
  onClick: undefined,
};

export default Alert;
